exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".logoUpload-7c5e3f4a{padding:10px;width:150px}.disclaimer-a0da72aa{color:#757575}.plusIcon-c0b9dbc1{border:2px solid #E0E0E0;border-radius:50%;display:block;margin:0 auto;background:#FFF;object-fit:cover}.visibilityContainer-d59554d3 select.visibilitySelect-d1d90f1c{width:285px}\n", ""]);

// Exports
exports.locals = {
	"logoUpload": "logoUpload-7c5e3f4a",
	"disclaimer": "disclaimer-a0da72aa",
	"plusIcon": "plusIcon-c0b9dbc1",
	"visibilityContainer": "visibilityContainer-d59554d3",
	"visibilitySelect": "visibilitySelect-d1d90f1c"
};